import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NbDateService, NbDialogRef, NbDialogService, NbToastrService, NbCardModule, NbButtonModule, NbIconModule, NbTooltipModule } from '@nebular/theme';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ViewContentComponent } from 'src/app/features/content/content-table/view-content/view-content.component';
import { ViewInsightComponent } from 'src/app/features/insights/insights-table/view-insight/view-insight.component';
import { InsightsState } from 'src/app/features/insights/redux';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { Insight } from '../../../../../models/insight';
import { PromotionSuccess } from '../../../redux';
import { CampaignService } from '../../../services/campaign.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
/*
This component acts as a handler for promoting campagins
*/

@Component({
    selector: 'app-campaign-promotion-component',
    templateUrl: './campaign-promotion-component.component.html',
    styleUrls: ['./campaign-promotion-component.component.scss'],
    imports: [NbCardModule, NgIf, NbButtonModule, NbIconModule, RouterLink, NbTooltipModule]
})
export class CampaignPromotionComponent implements OnInit, OnDestroy {
  public activeInsight$: Observable<any[]> = inject(Store).select(InsightsState.insightsActive);
  private unsubscribe: Subject<void> = new Subject();

  @Input() public campaign;
  @Input() public insights: Insight[] = [];
  @Input() public content;
  @Input() public username;
  @Input() public campaign_trigger;
  public spinner = false;
  public results: any = false;
  public errors: any = false;

  public target_environment = ENVIRONMENT.isProduction
    ? $localize`Production Environment`
    : $localize`Stage Environment`;

  constructor(
    protected ref: NbDialogRef<CampaignPromotionComponent>,
    public service: CampaignService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    protected dateService: NbDateService<Date>,
    private action$: Actions
  ) {}

  public ngOnInit() {
    if (this.insights.length == 0) {
      this.activeInsight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.insights = data));
    }
    if (!this.campaign_trigger) {
      this.campaign_trigger = this.insights.find((element) => element.id === Number(this.campaign.trigger_id));
    }
    this.action$.pipe(ofActionCompleted(PromotionSuccess), takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.clickedCancel();
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public clickedPromote() {
    this.dialogService
      .open(NgxGenericModalComponent, {
        context: {
          title: $localize`Before promotion you need to confirm you want to Promote: `,
          message: this.campaign.name
        }
      })
      .onClose.subscribe((data) => {
        if (data) {
          this.spinner = true;
          this.postCampaignAndInsight();
        }
      });
  }

  public viewInsight(event) {
    const found = this.insights.find((element) => element.id === event);
    if (found) {
      this.dialogService.open(ViewInsightComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          insight: found
        }
      });
    } else {
      this.toastrService.show(status, $localize`Insight with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public viewContent(event) {
    const found = this.content;
    if (found) {
      this.dialogService.open(ViewContentComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          content: found
        }
      });
    } else {
      this.toastrService.show(status, $localize`Content with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public clickedCancel() {
    this.service.promotionError = false;
    this.service.promotionResponse = false;
    this.service.promotionSpinner = false;
    this.ref.close();
  }

  public postCampaignAndInsight() {
    this.service.postPromoteCampaign(this.campaign.id, this.username);
  }
}
